import {
    default_tooltip_show, default_tooltip_hide, strVersion,
    strMainHeadline, strToolNameHeadline
} from '../Consts'
import { calcMark, createLinearGradeStructure } from '../Consts_GK.js'
import GradeChart from '../GradeChart/GradeChart.js';

import {
    ColDef,
    ColGroupDef,
    GetMainMenuItemsParams,
    GridApi,
    GridOptions,
    MenuItemDef,
    ModuleRegistry,
    PostProcessPopupParams,
    createGrid,
} from "@ag-grid-community/core";

import React, { useState, useRef, useEffect, useMemo, useCallback, forwardRef, useImperativeHandle } from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import { Form, Row, Col, FloatingLabel, OverlayTrigger, Tooltip, Button } from 'react-bootstrap';
import { CSSTransition } from 'react-transition-group';

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

// import { calcMark, gkFHSR60, gkFHSR90, gkIHK100, gkAbi60, gkAbi90, gkAbi24_80, gkAbi24_90, gkAbi24_100, gkAbi24_120 } from '../gk.js'
import { elements } from 'chart.js';

import './MainGrid.css';

// import { ModuleRegistry } from '@ag-grid-community/core';
// import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
// ModuleRegistry.registerModules([ClientSideRowModelModule]);

// import { ModuleRegistry } from '@ag-grid-community/core';
// import { RowGroupingModule } from '@ag-grid-enterprise/row-grouping';
// ModuleRegistry.registerModules([RowGroupingModule]);

// const printNode = (node, index) => {
//     if (node.group) {
//         console.log(index + ' -> group: ' + node.key);
//     } else {
//         console.log(
//             index + ' -> data: ' + node.data.c0 + ', ' + node.data.c1
//         );
//     }
// };

function useForceUpdate() {
    const [value, setValue] = useState(0); // integer state
    return () => setValue(value => value + 1); // update state to force render
}

function isNumeric(str) {
    if (typeof str != "string") return false;
    return !isNaN(str) &&
        !isNaN(parseFloat(str))
}

// function createItem(data) {
//     const item = {
//         c0: "Hacker",
//         c1: "Stefan",
//     };
//     return item;
// }

// function createNewRowItem(tabs) {
//     let rowCount = gridRef.current.api.getDisplayedRowCount();

//     const item = {
//         id: rowCount + (i + 1),
//         c0: tabs[0],
//         c1: tabs[1],
//     };

//     tabs.map(function (tab, index) {
//         if (index > 1) {
//             const key = 'a' + (index - 1);
//             item[key] = tab;
//         }
//     });
//     // console.log(item);
//     return item;
// }

// const dingsi = () => {
//     alert("called!");
// }

// const valueGetterSum = (params) => {
//     // return params.data.a + params.data.b;
//     if (params.node.rowIndex > 6 || params.node.rowIndex === 5) {
//         let keys = Object.keys(params.node.data);
//         let sum = 0;
//         keys.forEach((key) => {
//             if (key.charAt(0) === 'a' && key.length < 4) {
//                 sum += parseFloat(params.node.data[key].replace(",", "."));
//             }
//         })
//         return sum;
//     }
//     else if (params.node.rowIndex === 6) {
//         return "Summe";
//     }
// };

// const valueGetterMark = (params) => {
//     console.log("YYY",params);
//     if (params.node.rowIndex > 6) {
//     }
//     else if (params.node.rowIndex === 6) {
//         return "Nötchen";
//     }
// }

// const MainGrid = ({ parentState, callbackClipboard }) => {


const MainGrid = forwardRef((props, ref) => {

    const [showVisualGK, setShowVisualGK] = useState(true);
    const [isFullscreen, setIsFullscreen] = useState(false);
    const [showPedestalForm, setShowPedestalForm] = useState(false);

    const openFullscreen = () => setIsFullscreen(true);
    const closeFullscreen = () => setIsFullscreen(false);

    const [placeholderText, setPlaceholderText] = useState("Bitte wählen...");

    const [data, setData] = useState({});

    const [autoApplyGK, setAutoApplyGK] = useState(false);

    useEffect(() => {
        // console.log("useEff triggered - maxpoints?")
        // Your logic to create/update the data structure based on soben, sunten, knick
        // For this example, I'll assume you have a function that processes these props
        const generateChartData = (soben, sunten, knick) => {
            // Placeholder logic, replace with your actual data generation logic
            let updatedData = {};
            for (let i = 0; i <= 100; i++) {
                updatedData[i] = 6 - 5 * (i / 100); // Linear grade calculation example
            }

            // Modify data based on soben, sunten, knick
            //   if (soben !== -1) updatedData['soben'] = soben;
            //   if (sunten !== -1) updatedData['sunten'] = sunten;
            //   if (knick !== -1) updatedData['knick'] = knick;

            return updatedData;
        };


        // console.log(props.parentState)
        let max = Number(props.parentState.maxPunkte[0][props.parentState.maxPunkte[0].length - 1].value);
        setData(createLinearGradeStructure(max,
            props.parentState?.sockelOben || -1,
            props.parentState?.sockelUnten || -1,
            props.parentState?.knick || -1))
        // setData(generateChartData(props.parentState.soben, props.parentState.sunten, props.parentState.knick));
    }, [props.parentState.sockelOben,
    props.parentState.sockelUnten,
    props.parentState.knick,
    props.parentState.maxPunkte[0]]);

    function processDataFromClipboard(params) {
        const data = params.data;

        const focusedCell = gridRef.current.api.getFocusedCell();

        if (focusedCell && focusedCell.column.getColId() === 'c0' && focusedCell.rowIndex === 3) {
            console.log('>>> Custom paste logic for col1 row4');

            pasteFromClipBoard(3, data);

            // const pastedData = params.data;
            // const additionalRows = pastedData.map((row) => ({
            //     make: row[0] || '',
            //     model: row[1] || '',
            //     price: row[2] || 0,
            // }));
            // setRowData([...rowData, ...additionalRows]);

            return null;
        }
        return params.data;
    }
    const gridRef = useRef(null);
    const gridApiRef = useRef(null);
    const columnApiRef = useRef(null);

    var idRunner = 0;

    // const queryOpts = { name: 'clipboard-read', allowWithoutGesture: false };
    // var query = navigator.permissions.query(queryOpts);
    // console.log(query.state);

    useImperativeHandle(ref, () => ({
        getGridApi: () => gridRef.current.api, // Exposing grid API to parent component
        getGridColumnApi: () => gridRef.current.columnApi // Exposing column API to parent
    }));

    useEffect(() => {
        // if (gridRef.current) {
        //     gridApiRef.current = gridRef.current.api;
        //     columnApiRef.current = gridRef.current.columnApi;
        //     console.log("mounting...", gridRef.current);
        // }

        return () => {
            // console.log("Component is unmounting");
            // console.log(gridApiRef.current);
            // if (gridApiRef.current) {
            //     props.callbackHandleFixStateDataFromGrid(gridApiRef.current);
            //     console.log("syncing with state...")
            // }
        };
    }, []);

    useEffect(() => {
        // console.log("MainGrid useEffect --eloaded--", props);
        // console.log(props.parentState.taskNames[0].length)

        if (gridRef.current && gridRef.current.api) {

            // Reset column state, filter, and sorting
            gridRef.current.api.resetColumnState();  // Reset column state (sort, width, order)
            gridRef.current.api.setFilterModel(null); // Reset filters
            //   gridRef.current.api.setSortModel(null);   // Reset sorting

            gridRef.current.api.updateGridOptions({
                columnDefs: stdColDefs  // Set standard column definitions
            });

            // console.log("actually settin coldefs to", stdColDefs);

            const allRowNodes = [];

            gridRef.current.api.forEachNode((rowNode) => {
                allRowNodes.push(rowNode.data);
            });

            // Apply transaction to remove all rows
            gridRef.current.api.applyTransaction({ remove: allRowNodes });

            // Apply default row data to the grid
            gridRef.current.api.applyTransaction({ add: stdRowData });

            // Reset the row data to the standard row data using applyTransaction
            // gridRef.current.api.applyTransaction({ update: stdRowData });

            // let numTasks = props.parentState.taskNames[0].length - 2;
            let numTasks = props.parentState.columns.length - 4;

            loadFileFixColumns(numTasks, true);
            // loadFilePrepareRows();
            loadFileSetMetaData(props.parentState);
            loadFileSetRowData(props.parentState);
        }
        else {
            // console.log("gridRef.current might be null");
        }
    }, [props.parentState.eloaded]);

    const handleLeftMenuBar = () => {
        const e = document.getElementById("menu");
        // console.log(e.style.display.length);
        // console.log(e.style.display);
        // console.log(e.style.display === "undefined");
        (e.style.display !== "none" || e.style.display.length === 0) ? e.style.display = "none" : e.style.display = "block";
    }

    const progReset = () => {
        removeAllPupils();
        removeAllCols();
    }

    const removeAllCols = () => {
        const currCols = gridRef.current.api.getColumnDefs();
        let numToRemove = currCols.length - 5;
        console.log(numToRemove);
        currCols.splice(-(3 + numToRemove), numToRemove);

        gridRef.current.api.setColumnDefs([]);
        gridRef.current.api.setColumnDefs(currCols);

        gridRef.current.api.forEachNode((rowNode, index) => {

            for (let i = 0; i < numToRemove; i++) {
                let rColId = "a" + (i + 1);
                console.log("lets remove " + rColId);

                if (rowNode.data.hasOwnProperty(rColId)) {
                    switch (index) {
                        case 0:
                        case 1:
                            rowNode.data[rColId] = "";
                            delete rowNode.data[rColId];
                            break;
                        case 3:
                            break;
                        default:
                            rowNode.data[rColId] = "0";
                            delete rowNode.data[rColId];
                            break;
                    }
                }
            }
        });
        for (let i = 0; i < numToRemove; i++) {
            props.callbackHandleNumOfTasks(-1);
        }
    }

    const removeAllPupils = () => {
        gridRef.current.api.forEachNode((rowNode, index) => {
            if (index > 3) {

                const killer = gridRef.current.api.getRowNode(rowNode.id);
                console.log("KILLER " + killer.id + " " + killer.data.c0);
                gridRef.current.api.applyTransaction({
                    // remove: [rowNode.data],
                    // remove: [{ id: rowNode.id }],
                    remove: [{ id: killer.data.id }],

                    // remove: [rowNode],
                    // remove: [killer.data],
                    // remove: [killer],
                });
                props.callbackHandleNumOfPupils(-1);
                console.log(rowNode);
                delete rowNode.data;
                delete rowNode.id;
            }
        });
    }

    const genMinMaxAvgNote = () => {
        let g = props.parentState.grid;
        let gS = {
            "num": 0,
            "ming": 9999,
            "maxg": -1,
            "sumg": 0
        }
        g.forEach(item => {
            var grade = Number(item[item.length - 1].value);
            if (grade > gS.maxg) {
                gS.maxg = grade;
            }
            if (grade < gS.ming) {
                gS.ming = grade;
            }
            gS.sumg += grade;
            gS.num++;
        });
        if (gS.ming === 9999) {
            // return "Keine Daten vorhanden";
            // return ["Keine", "Daten", "vorhanden"];
            return ["", "", ""];
        } else {
            // return gS.ming + " / " + gS.maxg + " / " + Math.round(((gS.sumg / gS.num) + Number.EPSILON) * 100) / 100;;
            return [gS.ming, gS.maxg, Math.round(((gS.sumg / gS.num) + Number.EPSILON) * 100) / 100];
        }
    }

    const genMinMaxAvgPunkte = () => {
        let g = props.parentState.grid;
        let pS = {
            "num": 0,
            "minsum": 9999,
            "maxsum": -1,
            "sumsum": 0
        }
        g.forEach(item => {
            var sum = 0;
            for (var i = 2; i < item.length - 2; i++) {
                sum += Number(item[i].value);
            }
            if (sum > pS.maxsum) {
                pS.maxsum = sum;
            }
            if (sum < pS.minsum) {
                pS.minsum = sum;
            }
            pS.sumsum += sum;
            pS.num++;
        });
        if (pS.minsum === 9999) {
            // return "Keine Daten vorhanden";
            return ["", "", ""];
        } else {
            // return pS.minsum + " / " + pS.maxsum + " / " + Math.round(((pS.sumsum / pS.num) + Number.EPSILON) * 100) / 100;
            return [pS.minsum, pS.maxsum, Math.round(((pS.sumsum / pS.num) + Number.EPSILON) * 100) / 100];
        }
    }

    const valueGetterSum = (params) => {
        // return params.data.a + params.data.b;
        // if (params.node.rowIndex > 6 || params.node.rowIndex === 5) {
        if (params.node.rowIndex > 3 || params.node.rowIndex === 2) {
            let keys = Object.keys(params.node.data);
            let sum = 0;
            keys.forEach((key) => {
                if (key.charAt(0) === 'a' && key.length < 4) {
                    if (typeof (params.node.data[key]) === "string") {
                        sum += parseFloat(params.node.data[key].replace(",", "."));
                    }
                    else {
                        sum += parseFloat(params.node.data[key]);
                    }
                }
            });
            // if (params.node.rowIndex === 5) {
            //     props.callbackHandleSetRealMaxPoints(sum);
            // }
            params.node.data["summe"] = sum;
            props.callbackHandleChangeSumOfPupil(params.node.rowIndex, sum);
            if (params.node.rowIndex === 2) {
                props.callbackHandleSetMaxPointsSum(sum);
                // console.log("tueraluee")
            }
            return sum;
        }
    };

    // const valueGetterMark = (params) => {
    //     if (params.node.rowIndex > 3) {
    //         let gk = props.callbackHandleGetGK();
    //         let rmp = props.callbackHandleGetRealMaxPoints();
    //         if (gk > 0) {
    //             let mark = calcMark(Number(gk), Number(params.node.data.summe), 30, rmp);
    //             console.log(params.node)
    //             console.log(params.node.data.summe, mark)  // gk p max
    //             // gridRef.current.api.refreshCells();
    //             params.node.data["note"] = mark;
    //             return mark;
    //         }
    //     }
    // }


    const onHeaderCellContextMenu = (params) => {
        console.log("onHeaderCellContextMenu", params);
    }

    const C_CustomPasteButtons = props => {
        let state = 0; //
        let clsName0 = "";
        let clsName1 = "";
        let clsName2 = "";
        let clsName3 = "";
        let clsNameGrey = "";
        let clsNameGrey2 = "";

        let maxPunkte = gridRef.current.api.getRowNode("id3").data.summe;

        let numRows = gridRef.current.api.getDisplayedRowCount();
        let numCols = gridRef.current.api.getColumnDefs().length;

        if (numRows === 4 || numCols === 5) {
            clsName0 = "colorGrey";
            clsName1 = "colorGrey";
            clsName2 = "colorGrey";
            clsNameGrey = "colorGrey";
            clsNameGrey2 = "colorGrey";
            clsName3 = " colorRed";
        } else {
            state = 2;
            clsName3 += " colorGreen";
            if (maxPunkte === 0) {
                state = 1;
                clsName2 = "colorRed";
                clsName0 = "colorGrey";
                clsName1 = "colorGrey";
                clsNameGrey = "colorGrey";
            } else {
                clsName2 = "colorGreen";
            }

            maxPunkte === 0 ? clsName2 = "colorRed" : clsName2 = "colorGreen";
        }

        if (props.node.rowIndex === 0) {
            return (
                <>
                    {/* <button className={clsName0} title="Einfügen aus Excel: Klicken Sie bitte hier, um die Aufgabenbenennungen aus der Zwischenablage einzufügen." onClick={(e) => pasteFromClipBoard(0)}>&#9463;</button>&nbsp; */}
                    {/* <button className={clsName0} title="Einfügen aus Excel: Klicken Sie bitte hier, um die Aufgabenbenennungen aus der Zwischenablage einzufügen." onClick={(e) => pasteFromClipBoard(0)}>&#10071;</button>&nbsp; */}
                    <button className={clsName0} title="Einfügen aus Excel: Klicken Sie bitte hier, um die Aufgabenbenennungen aus der Zwischenablage einzufügen (optional)." onClick={(e) => pasteFromClipBoard(0)}>&#9998;</button>&nbsp;

                    {/* <button className={clsName0} title="Einfügen aus Excel: Klicken Sie bitte hier, um die Aufgabenbenennungen aus der Zwischenablage einzufügen." onClick={(e) => pasteFromClipBoard(0)}>&#8252;</button>&nbsp; */}
                    <span className={clsNameGrey}>
                        Aufgabenbenennungen
                    </span>
                </>
            )
        }
        if (props.node.rowIndex === 1) {
            return (
                <>
                    {/* <button className={clsName1} title="Einfügen aus Excel: Klicken Sie bitte hier, um die Anforderungsbereiche aus der Zwischenablage einzufügen." onClick={(e) => pasteFromClipBoard(1)}>&#9463;</button>&nbsp; */}
                    {/* <button className={clsName1} title="Einfügen aus Excel: Klicken Sie bitte hier, um die Anforderungsbereiche aus der Zwischenablage einzufügen." onClick={(e) => pasteFromClipBoard(1)}>&#10003;</button>&nbsp; */}
                    {/* <button className={clsName1} title="Einfügen aus Excel: Klicken Sie bitte hier, um die Anforderungsbereiche aus der Zwischenablage einzufügen." onClick={(e) => pasteFromClipBoard(1)}>&#10004;</button>&nbsp; */}
                    <button className={clsName1} title="Einfügen aus Excel: Klicken Sie bitte hier, um die Anforderungsbereiche aus der Zwischenablage einzufügen (optional)." onClick={(e) => pasteFromClipBoard(1)}>&#9998;</button>&nbsp;

                    <span className={clsNameGrey}>Anforderungsbereiche</span>
                </>
            )
        }
        if (props.node.rowIndex === 2) {
            return (
                <>
                    <button className={clsName2} title="Einfügen aus Excel: Klicken Sie bitte hier, um die Maximalpunktzahlen aus der Zwischenablage einzufügen." onClick={(e) => pasteFromClipBoard(2)}>
                        {/* &#9462; */}
                        {
                            (state < 2) && <> &#10071; </>
                        }
                        {
                            (state > 1) && <> &#10004; </>
                        }

                    </button>&nbsp;
                    <span className={clsNameGrey2}>Maximalpunktzahlen</span>
                </>
            )
        }
        if (props.node.rowIndex === 3) {
            return (
                <>
                    <button className={clsName3} title="Einfügen aus Excel: Klicken Sie bitte hier, um die Schülerdaten/-punktzahlen aus der Zwischenablage einzufügen." onClick={(e) => pasteFromClipBoard(3)}>
                        {/* &#9461; */}
                        {
                            (state === 0) && <> &#10071; </>
                        }
                        {
                            (state !== 0) && <> &#10004; </>
                        }
                    </button>&nbsp;
                    Name
                </>
            )
        }

        // if (props.node.data.c0 !== undefined) {
        if (props.node.data !== undefined) {
            return (
                props.node.data.c0
            )
        }

    };

    const C_ActionDeletAddeRow = props => {
        return (
            <>
                {props.node.rowIndex === 3 &&
                    <>
                        {/* <button className="pointerFinger" title="SchülerIn hinzufügen" data-action="add" > + </button> */}

                        <OverlayTrigger
                            placement="top"
                            delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                            overlay={<Tooltip className="custom-tooltip">
                                Klicken Sie hier, um einen Schüler / eine Schülerin hinzuzufügen.
                            </Tooltip>}
                        >
                            <Button variant="outline-light" size="lg" className="p-0 m-0"
                                // title="SchülerIn hinzufügen"
                                data-action="add">
                                <i className="bi bi-person-plus" data-action="add"></i>
                            </Button>
                        </OverlayTrigger>

                    </>
                }
                {props.node.rowIndex > 3 &&
                    <>
                        {/* <button className="pointerFinger" title="Schüler entfernen" data-action="delete" > - </button> */}
                        <OverlayTrigger
                            placement="top"
                            delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                            overlay={<Tooltip className="custom-tooltip">
                                Klicken Sie hier, um diesen Schüler / diese Schülerin zu entfernen.
                            </Tooltip>}
                        >
                            <Button variant="outline-light" size="lg" className="p-0 m-0"
                                // title="SchülerIn entfernen"
                                data-action="delete">
                                <i className="bi bi-person-x" data-action="delete"></i>
                            </Button>
                        </OverlayTrigger>

                    </>
                }
            </>
        )
    };

    const C_CustomHeaderAddColumn = props => {
        return (
            <>
                {/* <button onClick={changeColumnsAdd}> + </button> */}
                Summe
            </>
        )
    };


    const C_CustomHeaderRemoveColumn = props => {
        return (
            <>
                {/* {props.displayName}&nbsp;&nbsp;&nbsp;<button onClick={changeColumnsRemoveSpecific}> X </button> */}
                {props.displayName}
            </>
        )
    };

    const C_CustomHeaderActionColumn = props => {
        return (
            <>
                {/* <button className="pointerFinger" title="Aufgabe hinzufügen" onClick={changeColumnsAdd}> + </button> */}


                <OverlayTrigger
                    placement="top"
                    delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                    overlay={<Tooltip className="custom-tooltip">
                        Klicken Sie hier, um eine Aufgabe hinzuzufügen.
                    </Tooltip>}
                >
                    <Button variant="outline-light" size="lg" className="p-0 m-0"
                        // title="Aufgabe hinzufügen" 
                        onClick={(e) => changeColumnsAdd(false)}>
                        <i className="bi bi-plus-circle"></i>
                    </Button>
                </OverlayTrigger>

                <OverlayTrigger
                    placement="top"
                    delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                    overlay={<Tooltip className="custom-tooltip">
                        Klicken Sie hier, um die letzte Aufgabe zu entfernen.
                    </Tooltip>}
                >
                    <Button variant="outline-light" size="lg" className="p-0 m-0"
                        // title="Aufgabe entfernen" 
                        onClick={changeColumnsRemove}>
                        <i className="bi bi-dash-circle"></i>
                    </Button>
                </OverlayTrigger>
            </>
        )
    };


    const changeColumnsRemoveSpecific = props => {
        console.log(props);
    }

    const C_CustomHeader = props => {
        return (
            <>
                {/* <label htmlFor="txtMaxPunkte">Maximalpunktzahl<br />(Skalierung Abi-Notenschl&uuml;ssel)</label><br />
                    <input type="text" id="txtMaxPunkte" /><br/> */}

                <select onChange={handleGradesKeyChanged}>
                    <option value="0">Notenschlüssel</option>
                    <option value="1">Linear</option>
                    <option value="7">30 VP Schl&uuml;ssel (bis 2023)</option>
                    <option value="2">Abitur 60 VP (bis 2023)</option>
                    <option value="3">Abitur 90 VP (bis 2023)</option>
                    <option value="8">Abitur 80 BE (ab 2024)</option>
                    <option value="9">Abitur 90 BE (ab 2024)</option>
                    <option value="10">Abitur 100 BE (ab 2024)</option>
                    <option value="11">Abitur 120 BE (ab 2024)</option>
                    <option value="4">FHSR 60 Punkte</option>
                    <option value="5">FHSR 90 Punkte</option>
                    <option value="6">IHK 100 Punkte</option>
                </select>
            </>
        )
    };

    // const C_ChangeGK = props => {
    //     return (
    //         <>
    //             <label htmlFor="txtMaxPunkte">Maximalpunktzahl<br />(Skalierung Abi-Notenschl&uuml;ssel)</label><br />
    //             <input type="text" id="txtMaxPunkte" /><br />

    //             <select onChange={handleGradesKeyChanged}>
    //                 <option value="0">Notenschlüssel</option>
    //                 <option value="1">Linear</option>
    //                 <option value="7">30 VP Schl&uuml;ssel (bis 2023)</option>
    //                 <option value="2">Abitur 60 VP (bis 2023)</option>
    //                 <option value="3">Abitur 90 VP (bis 2023)</option>
    //                 <option value="8">Abitur 80 BE (ab 2024)</option>
    //                 <option value="9">Abitur 90 BE (ab 2024)</option>
    //                 <option value="10">Abitur 100 BE (ab 2024)</option>
    //                 <option value="11">Abitur 120 BE (ab 2024)</option>
    //                 <option value="4">FHSR 60 Punkte</option>
    //                 <option value="5">FHSR 90 Punkte</option>
    //                 <option value="6">IHK 100 Punkte</option>
    //             </select>
    //         </>
    //     )
    // };

    const genFilename = () => {
        // genFilename = () => {
        var invalid_chars = /[^a-zA-Z0-9_-]/g;
        let fileName = props.parentState.schuljahr.replace(invalid_chars, "") + "-" +
            props.parentState.fach.replace(invalid_chars, "") + "-" +
            props.parentState.klasse.replace(invalid_chars, "") + ".json";

        if (fileName === "--.json") {
            return "Bitte ergänzen Sie die Metadaten."
        }
        else {
            return fileName;
        }
    }

    const handleChangeNotenschluessel = (gk) => {
        // console.log(props.parentState);
        console.log("Hello from handleChangeNotenschluessel", gk);
        let gr = props.parentState.grid;
        let mp = props.parentState.maxPunkte;
        let rmp = props.callbackHandleGetRealMaxPoints();

        let soben = props.parentState?.sockelOben ?? -1;
        soben = soben === 0 ? -1 : soben;
        let sunten = props.parentState?.sockelUnten ?? -1;
        sunten = sunten === 0 ? -1 : sunten;
        let knick = props.parentState?.knick ?? -1;
        knick = knick === 0 ? -1 : knick;
        console.log(props.parentState);
        console.log("handleChangeNotenschluessel", soben, sunten, knick);

        let max = Number(mp[0][mp[0].length - 1].value);
        // console.log("MAX: " + max);
        let marks = [];
        for (var row = 0; row < gr.length; row++) {
            let p = Number(gr[row][gr[row].length - 2].value);
            // let note = calcMark(Number(gk), p, max, rmp);
            let note = calcMark(Number(gk), p, max, rmp, soben, sunten, knick);
            gr[row][gr[row].length - 1] = { value: '' + note };
            // let name = "id" + (row + 5);
            // console.log(typeof (name), name);
            // let rowNode = gridRef.current.api.getRowNode("id5");
            isFinite(note) ? marks[row] = note : marks[row] = "Bitte Max-Punkte eingeben";
        }

        // console.log(marks);

        gridRef.current.api.forEachNode((rowNode, index) => {
            if (index > 3) {
                // console.log('node ' + rowNode.data.note + ' is in the grid');
                rowNode.data.note = marks[index - 4];
            }
        });
    }

    const handleGradesKeyChanged = (params) => {
        let index = params.target.selectedIndex;
        let gk = params.target.value;
        // let statusText = "Der Notenschlüssel  '" + params.target[index].text + "' wurde auf Ihre Klassenarbeit angewandt."
        let statusText = "Der Notenschlüssel  '" + params.target[index].text + "' wurde für Ihre Klassenarbeit ausgewählt."
        setPlaceholderText("Bitte wählen... (Aktuell: " + params.target[index].text + ")");

        let soben = props.parentState?.sockelOben ?? -1;
        soben = soben === 0 ? -1 : soben;
        let sunten = props.parentState?.sockelUnten ?? -1;
        sunten = sunten === 0 ? -1 : sunten;
        let knick = props.parentState?.knick ?? -1;
        knick = knick === 0 ? -1 : knick;

        soben !== -1 ? statusText += " Sockel oben: " + soben + " Punkte (und darüber)." : statusText = statusText;
        sunten !== -1 ? statusText += " Sockel unten: " + sunten + " Punkte (und darunter)." : statusText = statusText;
        knick !== -1 ? statusText += " Knick (ausreichend mit 4,4) bei " + knick + " Punkten." : statusText = statusText;

        props.callbackHandleSetStatusInfo(statusText, "Notenschlüssel ausgewählt", "info");
        handleChangeNotenschluessel(gk);
        // props.callbackHandleChangeNotenschluessel(params.target.value);
        props.callbackHandleSetGK(gk);
        params.target.value = "0";
        props.callbackHandleFixStateDataFromGrid(gridRef.current.api); // YYY
    }

    const stdRowData = [
        { id: 'id1', c0: 'Aufgabenbenennung' },
        { id: 'id2', c0: "Anforderungsniveau" },
        { id: 'id3', c0: "Maximalpunkte" },
        { id: 'id4', c0: "Name", c1: "Vorname | Pseudonym" }
    ]

    const [rowData, setRowData] = useState(stdRowData);

    const customCellRenderer = (params) => {
        // const data = params.data;

        // console.log("hello from customCellRenderer")
        if (params.node.rowIndex === 3 && params.colDef.field === 'c0') {
            const renderTooltip = (props) => (
                <Tooltip className="custom-tooltip" id="button-tooltip" {...props}>
                    Markieren Sie diese Zelle und nutzen Sie dann [STRG]-[V] (Einfügen), um Schülerdaten aus Ihrer Zwischenablage en bloc einzufügen.
                </Tooltip>
            );

            return (
                <OverlayTrigger
                    placement="top"
                    delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                    overlay={renderTooltip}
                >
                    <span className="pointerHelp">Name | Pseudonym</span>
                </OverlayTrigger>
            );
        }
        // console.log("i am actually returning default in customCellRenderer")
        return params.value;
    };

    const stdColDefs = [
        // {
        //     field: 'cb',
        //     headerName: "",
        //     headerCheckboxSelection: false,
        //     checkboxSelection: params => params.node.rowIndex >= 4,
        //     width: 50,
        //     pinned: "left",
        //     lockPosition: "left",
        //     suppressMovable: true,
        //     editable: false,
        // },
        {
            field: 'c0',
            width: 100,
            headerName: "",
            suppressMovable: true,
            sortable: false,
            lockPosition: "left",
            colSpan: p => p.node.rowIndex < 3 ? 2 : 1,
            cellStyle: p => p.node.rowIndex < 4 ? { fontWeight: "bold" } : null,
            editable: p => p.node.rowIndex < 4 ? false : true,
            rowDrag: false,
            // mainMenuItems: (params) => {
            //     const menuItems = [];
            //     const itemsToExclude = ["separator", "pinSubMenu", "valueAggSubMenu", "columnChooser"];
            //     params.defaultItems.forEach((item) => {
            //         if (itemsToExclude.indexOf(item) < 0) {
            //             menuItems.push(item);
            //         }
            //     });
            //     return menuItems;
            // },
            cellRenderer: customCellRenderer,
        },
        {
            field: 'c1',
            width: 100,
            headerName: "",
            suppressMovable: true,
            // lockPosition: "left",
            cellStyle: p => p.node.rowIndex <= 3 ? { fontWeight: "bold" } : null,
            editable: params => params.node.rowIndex <= 3 ? false : true
        },
        {
            field: 'summe',
            width: 10,
            headerName: "Summe",
            suppressMovable: true,
            lockPosition: "right",
            editable: false,
            valueGetter: valueGetterSum,
            headerComponent: C_CustomHeaderAddColumn,
        },
        {
            field: 'note',
            width: 10,
            headerName: "Note",
            suppressMovable: true,
            lockPosition: "right",
            editable: params => (params.node.rowIndex > 3) ? true : false,
            valueSetter: params => {
                if (params.node.rowIndex > 3) {
                    if (isNumeric(params.newValue)) {
                        params.data.note = params.newValue;
                    }
                }
                return true;
            },
        },
        {
            field: 'action',
            width: 80,
            headerName: "",
            suppressMovable: true,
            // lockPosition: "right",
            pinned: "right",
            editable: false,
            cellRenderer: C_ActionDeletAddeRow,
            colId: "action",
            headerComponent: C_CustomHeaderActionColumn,
        },
    ];

    const [columnDefs, setColumnDefs] = useState(stdColDefs); // YYYY

    const removeSelectedRows = () => {
        const selectedRows = gridRef.current.api.getSelectedRows();  // Get the selected rows
        gridRef.current.api.applyTransaction({ remove: selectedRows });  // Remove the selected rows
    };


    // let numTasks = props.parentState.taskNames[0].length - 2;
    // let startIndex = 3;
    // for (let i = 0; i < numTasks - 1; i++) {

    //     stdColDefs.splice(startIndex + i, 0, {
    //         field: 'a' + (i + 2),
    //         lockVisible: true,
    //         editable: params => (params.node.rowIndex === 3) ? false : true,
    //         valueSetter: params => {
    //             if (params.node.rowIndex < 2) {
    //                 params.data.a1 = params.newValue;
    //             }
    //             if (params.node.rowIndex > 3 ||
    //                 params.node.rowIndex === 2) {
    //                 if (isNumeric(params.newValue)) {
    //                     params.data.a1 = params.newValue;
    //                 }
    //             }
    //             return true;
    //         },
    //         headerComponent: C_CustomHeaderRemoveColumn,
    //     });
    // }

    // const gridRef = useRef();

    const handleManualPaste = (e) => {
        console.log(e);
        if (e.target.tagName === "INPUT") {
            return;
        }

        const states = {
            alt: e.altKey,
            ctrl: e.ctrlKey,
            meta: e.metaKey,
            shift: e.shiftKey,
        };

        const key = e.key;
        const code = e.code;

        let rID = "";
        let sr = null;

        try {
            if (gridRef.current !== undefined) {
                console.log(gridRef);
                console.log(gridRef.current);
                console.log(gridRef.current.api);

                sr = gridRef.current.api.getSelectedNodes()[0];
            }
            if (sr !== undefined && sr !== null) {
                rID = sr.data.id;
            }
        } catch (error) {
            console.warn(error);
        }

        if ((rID !== "") && (states.ctrl || states.meta) && key === 'v') {
            let EleTxtPasteCB = document.getElementById("txtPasteCB");
            EleTxtPasteCB.value = "";
            EleTxtPasteCB.focus();
            setTimeout(() => {
                const pVal = EleTxtPasteCB.value;
                // console.log(pVal);
                // document.getElementById("txtSchuljahr").value = pVal;
                switch (rID) {
                    case 'id1':
                    case 'id2':
                    case 'id3':
                        let row = sr.data;
                        let tabs = pVal.trim().split('\t');
                        tabs.map(function (tab, index) {
                            const key = 'a' + (index + 1);
                            row[key] = tab;
                            console.log("jo bin drin mit " + key + " " + tab);
                        });
                        // gridRef.current.api.refreshCells();
                        break;
                    default:
                        console.log(pVal);
                        props.callbackHandleClipboardData(pVal);
                        let lines = pVal.split('\n');
                        const newStore = rowData.slice();
                        fixNumCols(lines);
                        lines.map(function (item, index) {
                            let tabs = item.trim().split('\t');
                            const newItem = createNewRowItem(tabs, index);
                            newStore.push(newItem);
                        });
                        setRowData(newStore);
                }
            }, "200");
            props.callbackHandleFixStateDataFromGrid(gridRef.current.api); // YYY
            gridRef.current.api.refreshCells();
        }
        else {
            console.log("KEY DETECTED")
            return;
        }




        // switch (rID) {
        //     case 'id1':
        //     case 'id2':
        //     case 'id3':
        //         let row = sr;
        //         navigator.clipboard
        //             .readText()
        //             .then((clipText) => {
        //                 console.log(clipText);
        //                 let tabs = clipText.trim().split('\t');
        //                 // fixNumCols(clipText); // !!!
        //                 tabs.map(function (tab, index) {
        //                     const key = 'a' + (index + 1);
        //                     row[key] = tab;
        //                 });
        //                 console.log(row);
        //                 gridRef.current.api.refreshCells();
        //             });
        //         break;
        // default:
        //     navigator.clipboard
        //         .readText()
        //         .then((clipText) => {
        //             console.log(clipText);
        //             props.callbackHandleClipboardData(clipText);
        //             let lines = clipText.split('\n');
        //             const newStore = rowData.slice();
        //             // console.log(newStore);
        //             // console.log(lines);
        //             fixNumCols(lines);
        //             lines.map(function (item, index) {
        //                 let tabs = item.trim().split('\t');
        //                 const newItem = createNewRowItem(tabs, index);
        //                 newStore.push(newItem);
        //             });
        //             setRowData(newStore);
        //         });
        // }

        // try {
        //     const selRows = gridRef.current.api.getSelectedRows();
        //     const selNodes = gridRef.current.api.getSelectedNodes();
        //     if ((states.ctrl || states.meta) && key === 'v') {
        //         if (selRows.length === 0) {
        //             console.log("no rows selected");
        //         }
        //         else {

        //         }
        //         let EleTxtPasteCB = document.getElementById("txtPasteCB");
        //         console.log(EleTxtPasteCB);
        //         EleTxtPasteCB.value = "";
        //         EleTxtPasteCB.focus();
        //         // e.preventDefault();
        //         console.log("BINGO");
        //         // document.activeElement.blur();
        //         // console.log(document.activeElement.value);
        //         // EleTxtPasteCB.blur();
        //         // console.log(EleTxtPasteCB.value);
        //         setTimeout(() => {
        //             // EleTxtPasteCB.focus();
        //             // console.log("FOCUS");
        //             console.log(EleTxtPasteCB.value);
        //             // console.log(document.activeElement.value);
        //             // document.activeElement.blur();
        //             document.getElementById("txtSchuljahr").value = EleTxtPasteCB.value;
        //         }, "200");
        //     }

        // } catch (error) {
        //     console.log(error);
        // }
    }

    // // colDefs = stdColDefs;
    // let numTasks = props.parentState.taskNames[0].length - 2;
    // // changeColumnsReset();
    // gridRef.current.api.refreshCells();

    // for (let i = 0; i < numTasks; i++) {
    //     changeColumnsAdd();
    // }
    // // fJSON.taskNames[0].length - 3;)

    // const [rowData, setRowData] = useState([]);

    function createNewRowItem(tabs, index) {
        let rowCount = gridRef.current.api.getDisplayedRowCount();

        const item = {
            id: rowCount + 1 + index,
            c0: tabs[0],
            c1: tabs[1],
        };

        tabs.map(function (tab, index) {
            if (index > 1) {
                const key = 'a' + (index - 1);
                // item[key] = tab;
                item[key] = tab.replace(",", ".");
            }
        });
        console.log(item);
        return item;
    }

    // const setPrinterFriendly = (api) => {
    //     const eGridDiv = document.querySelector('#myGrid');
    //     eGridDiv.style.width = '';
    //     eGridDiv.style.height = '';
    //     api.sizeColumnsToFit();
    //     api.setDomLayout('print');
    // };

    // const setNormal = (api) => {
    //     const eGridDiv = document.querySelector('#myGrid');
    //     eGridDiv.style.width = '100%';
    //     eGridDiv.style.height = '500px';
    //     api.setDomLayout();
    // };

    // const onBtPrint = useCallback(() => {
    //     const api = gridRef.current.api;
    //     setPrinterFriendly(api);
    //     setTimeout(function () {
    //         window.print();
    //         setNormal(api);
    //     }, 2000);
    // }, [window.print]);


    const onBtVideoTutorial = () => {
        alert("In Arbeit, kommt bald!")
    }

    const onBtPrint = () => {
        // alert("printerling!");

        props.callbackHandleFixStateDataFromGrid(gridRef.current.api);

        let printHTML = '<!DOCTYPE html><html lang="de"><head><meta charset="utf-8" />';
        printHTML += '<style>body{color: black; font-size: 14px; font-family: Roboto, arial;}';
        printHTML += 'table {width: 100%;}';
        printHTML += 'th, td {border: 1px solid grey;}.bolder{font-weight: bolder;}';
        printHTML += '</style>';
        printHTML += '</head><body><div style="margin-left: 50px;">';
        // let c = this.state.columns;
        let gr = props.parentState.grid;

        let cab = props.parentState.namelessColsAbereiche;
        let ab = props.parentState.abereiche;
        let tn = props.parentState.taskNames;

        // let cmp = this.state.namelessColsMaxPunkte;
        let mp = props.parentState.maxPunkte;

        printHTML += "Dateiname: " + genFilename() + "<br>";
        printHTML += "Schuljahr: " + props.parentState.schuljahr + "<br>";
        printHTML += "Fach: " + props.parentState.fach + "<br>";
        printHTML += "Klasse: " + props.parentState.klasse + "<br>";;
        printHTML += "SchülerInnen: " + props.parentState.grid.length + "<br>";;
        printHTML += "Punkte (min/max/avg): " + genMinMaxAvgPunkte() + "<br>";;
        printHTML += "Noten (min/max/avg): " + genMinMaxAvgNote();

        printHTML += "<table id='printTable'><tr><td colspan='2' style='border: none;'>&nbsp;</td>";
        var col;
        for (col = 2; col < cab.length; col++) {
            let aName = tn[0][col].value;
            console.log(aName.length);
            if (aName.length === 0) {
                aName = "A" + (col - 1);
            }
            // printHTML += "<th>" + cab[col].label + "</th>";
            printHTML += "<th>" + aName + "</th>";
        }
        printHTML += "<th>Summe</th><th>Note</th></tr>";

        printHTML += '<tr><td colspan="2"><span className="bolder">Anforderungsbereiche</span></td>';
        for (col = 2; col < ab[0].length; col++) {
            printHTML += "<td>" + ab[0][col].value + "</td>";
        }
        printHTML += "<td>&nbsp;</td><td>&nbsp;</td></tr>";

        printHTML += '<tr><td colspan="2"><span className="bolder">Maximalpunkte</span></td>';
        for (col = 2; col < mp[0].length; col++) {
            printHTML += "<td>" + mp[0][col].value + "</td>";
        }
        printHTML += "<td>&nbsp;</td></tr>";

        printHTML += '<tr><td><span className="bolder">Name</span></td><td><span className="bolder">Vorname</span></td>';
        printHTML += "<td colspan='" + (mp[0].length - 1) + "'></td>";
        printHTML += "</tr>";

        for (var row = 0; row < gr.length; row++) {
            printHTML += "<tr>";
            for (col = 0; col < gr[row].length; col++) {
                printHTML += "<td>" + gr[row][col].value + "</td>";
            }
            printHTML += "</tr>";
        }

        printHTML += "</table></div></body></html>";

        var pri = document.getElementById("ifprint").contentWindow;
        pri.document.open(); pri.document.write(printHTML);
        pri.document.close();
        pri.focus();
        pri.print();
    }

    const giveClipBoardHints = () => {
        alert("kljfshdsj")
    }

    const renderStatusBlock = () => {

        let maxP = genMinMaxAvgPunkte();
        let maxN = genMinMaxAvgNote();
        // let clipper = 0;
        // let pri = document.getElementById("clipBoardInfo");

        // try {
        //     clipper = navigator.permissions.query({ name: 'clipboard-read' })
        //         .then(function (result) {
        //             if (result.state !== 'granted') {
        //                 console.log("Clipboard access not granted!");
        //                 return 0;
        //             }
        //             else {
        //                 return 1;
        //             }
        //         });
        //     clipper = clipper.then(function (cl) {
        //         return cl;
        //     });
        // } catch (error) {
        //     console.log("navigator.permissions.query not available!");
        // }
        // console.log("clipper ist jetzt >> " + clipper)

        // if (clipper !== 1) {
        //     let writeHTML = "<p className='bold'>&#10071;Ihre Zwischenablage ist programmatisch nicht verfügbar!&#10071;</p>" +
        //         "<p>Bitte erlauben Sie den Zugriff auf die Zwischenablage in Ihren Browsereinstellungen. Falls Sie Firefox nutzen, müssen Sie mit der Tastekombination STRG-V arbeiten.</p>";
        //     console.log(pri);
        //     if (pri !== null && pri !== undefined) {
        //         pri.innerHTML = writeHTML;
        //     }
        // }

        return (
            <>
                <table id="statusBlockTable" className="fontBold">
                    <tbody>
                        {/* {console.log(props.parentState.clipboard)} */}
                        {/* <tr><td>SchülerInnen</td><td><span className="bold">{props.parentState.grid.length}</span></td><td>Aufgaben</td><td><span className="bold">{props.parentState.columns.length - 4}</span></td></tr> */}
                        <tr><td>SchülerInnen</td><td></td><td><span className="bold">{props.parentState.grid.length}</span></td><td></td></tr>
                        <tr><td>Aufgaben</td><td></td><td><span className="bold">{props.parentState.columns.length - 4}</span></td><td></td></tr>
                        <tr><td colSpan="4">&nbsp;</td></tr>
                        <tr><td>&nbsp;</td><td>Minimum</td><td>Maximum</td><td>Durchschnitt</td></tr>
                        <tr><td>&nbsp;</td><td>Min</td><td>Max</td><td>Avg</td></tr>
                        <tr><td>Punkte</td><td><span className="bold">{maxP[0]}</span></td><td><span className="bold">{maxP[1]}</span></td><td><span className="bold">{maxP[2]}</span></td></tr>
                        <tr><td>Note</td><td><span className="bold">{maxN[0]}</span></td><td><span className="bold">{maxN[1]}</span></td><td><span className="bold">{maxN[2]}</span></td></tr>
                        <tr><td colSpan="4">&nbsp;</td></tr>
                        <tr><td>Dateiname</td><td colSpan="3"><span className="bold">{genFilename()}</span></td></tr>
                        <tr><td className="centerText" colSpan={4}><button className="btnRefresh" onClick={(e) => props.callbackHandleFixStateDataFromGrid(gridRef.current.api)}>Statusinformationen aktualisieren</button></td></tr>
                    </tbody>
                </table>
            </>
        )
    }

    // const loadFileSetMetaData = useCallback((dataBlob) => {
    // const loadFileSetMetaData = (dataBlob) => {

    //     let rowNode = gridRef.current.api.getRowNode("id1");
    //     for (let i = 2; i < dataBlob["taskNames"][0].length; i++) {
    //         rowNode.setDataValue('a' + (i - 1), dataBlob["taskNames"][0][i].value);
    //     }

    //     rowNode = gridRef.current.api.getRowNode("id2");
    //     for (let i = 2; i < dataBlob["abereiche"][0].length; i++) {
    //         rowNode.setDataValue('a' + (i - 1), dataBlob["abereiche"][0][i].value);
    //     }

    //     rowNode = gridRef.current.api.getRowNode("id3");
    //     for (let i = 2; i < dataBlob["maxPunkte"][0].length - 1; i++) {
    //         rowNode.setDataValue('a' + (i - 1), dataBlob["maxPunkte"][0][i].value);
    //     }
    // }
    //, []);

    const loadFileSetMetaData = (dataBlob) => {
        const rowDataUpdates = [];

        // Update for row with id1
        let rowNode = gridRef.current.api.getRowNode("id1");
        const updatedRow1 = { ...rowNode.data }; // Clone existing row data

        // Make sure the ID field is included
        updatedRow1.id = rowNode.data.id;

        for (let i = 2; i < dataBlob["taskNames"][0].length; i++) {
            updatedRow1['a' + (i - 1)] = dataBlob["taskNames"][0][i].value;
        }

        rowDataUpdates.push(updatedRow1); // Add updated row to updates

        // Update for row with id2
        rowNode = gridRef.current.api.getRowNode("id2");
        const updatedRow2 = { ...rowNode.data }; // Clone existing row data

        updatedRow2.id = rowNode.data.id;

        for (let i = 2; i < dataBlob["abereiche"][0].length; i++) {
            updatedRow2['a' + (i - 1)] = dataBlob["abereiche"][0][i].value;
        }

        rowDataUpdates.push(updatedRow2); // Add updated row to updates

        // Update for row with id3
        rowNode = gridRef.current.api.getRowNode("id3");
        const updatedRow3 = { ...rowNode.data }; // Clone existing row data

        updatedRow3.id = rowNode.data.id;

        for (let i = 2; i < dataBlob["maxPunkte"][0].length - 1; i++) {
            updatedRow3['a' + (i - 1)] = dataBlob["maxPunkte"][0][i].value;
        }

        rowDataUpdates.push(updatedRow3); // Add updated row to updates

        // Apply the transaction to update rows in one go

        const transactionResult = gridRef.current.api.applyTransaction({ update: rowDataUpdates });

        // Log the transaction result for debugging
        // console.log("Transaction Result:", transactionResult);

    };

    const loadFileSetRowData = (dataBlob) => {
        let newItems = [];  // Store all the new items to be added in the grid
        let newItem = {};
        for (let i = 0; i < dataBlob.grid.length; i++) {
            // console.log("Runner: " + idRunner);
            idRunner = idRunner + 1;
            let pupil = dataBlob.grid[i];
            // console.log(pupil);

            // Build new row item
            newItem = {
                id: idRunner,              // Increment unique ID
                c0: pupil[0].value,        // Assuming 'pupil[0]' holds data for column 'c0'
                c1: pupil[1].value,        // Assuming 'pupil[1]' holds data for column 'c1'
            };

            // Add dynamically named fields ('a1', 'a2', etc.)
            for (let i = 2; i < pupil.length - 2; i++) {
                newItem['a' + (i - 1)] = pupil[i].value;  // Dynamically add fields
            }

            newItem['summe'] = pupil[pupil.length - 2].value;  // Add sum
            newItem['note'] = pupil[pupil.length - 1].value;   // Add note
            // console.log(newItem);

            // Push newItem to the newItems array
            newItems.push(newItem);
        }

        // Apply the transaction to add the new rows to the grid
        gridRef.current.api.applyTransaction({ add: newItems });

        // console.log("Runner is final: " + idRunner);
    };

    // const loadFileSetRowData = (dataBlob) => {
    //     let newStore = rowData.slice(0, 4);
    //     let newItem = {};
    //     for (let i = 0; i < dataBlob.grid.length; i++) {
    //         console.log("Runner: " + idRunner);
    //         idRunner = idRunner + 1;
    //         let pupil = dataBlob.grid[i];
    //         console.log(pupil);

    //         newItem = {
    //             id: idRunner,
    //             c0: pupil[0].value,
    //             c1: pupil[1].value,
    //         };
    //         for (let i = 2; i < pupil.length - 2; i++) {
    //             newItem['a' + (i - 1)] = pupil[i].value;
    //         }
    //         newItem['summe'] = pupil[pupil.length - 2].value;
    //         newItem['note'] = pupil[pupil.length - 1].value;
    //         console.log(newItem);
    //         newStore.push(newItem);
    //     }
    //     setRowData(newStore);
    //     console.log("Runner is final: " + idRunner);
    // };

    const loadFilePrepareColumns = (numTasks) => {
        changeColumnsReset();
        gridRef.current.api.refreshCells();
        changeColumnsLoad(numTasks);
        // for (let i = 0; i < numTasks; i++) {
        //     changeColumnsAdd();
        // }
    }

    const loadFileFixColumns = (numTasks, freshLoad = false) => {
        // console.log("hello from loadFileFixColumns");
        while (gridRef.current.api.getColumnDefs().length > 5) {
            changeColumnsRemove();
        }
        for (let i = 0; i < numTasks; i++) {
            changeColumnsAdd(freshLoad);
        }
    }

    const loadFilePrepareRows = () => {
        removeAllPupils();
        // changeRowsReset();
        // gridRef.current.api.refreshCells();
    }

    const localHandleFileLoadChange = (e, x) => {
        console.log("HELLO FROM localHandleFileLoadChange");
        e.preventDefault();
        if (e.target.files.length > 0) {
            const files = e.target.files;
            const file = files[0];
            if (file.type.startsWith("application/json")) {
                const reader = new FileReader();
                reader.onloadend = (function (theFile) {
                    return function (e) {
                        if (e.target.readyState === FileReader.DONE) {
                            const fContent = e.target.result;
                            let fJSON = JSON.parse(fContent);
                            if (!fJSON.hasOwnProperty('taskNames')) {
                                const numTasks = fJSON.abereiche[0].length;
                                fJSON['taskNames'] = [];
                                fJSON['taskNames'][0] = [];
                                fJSON['taskNames'][0][0] = { value: "" };
                                fJSON['taskNames'][0][1] = { value: "" };
                                for (let i = 2; i < numTasks; i++) {
                                    fJSON['taskNames'][0][i] = { value: "A" + (i - 1) };
                                }
                            }
                            console.log("SHOULD UPDATE GRID", gridRef);
                            console.log(fJSON);

                            let numTasks = fJSON.taskNames[0].length - 2;
                            console.log("NUMTASKS:" + numTasks);
                            console.log("RUNNER IS " + idRunner);

                            // loadFilePrepareColumns(numTasks);
                            loadFileFixColumns(numTasks);

                            loadFilePrepareRows();
                            loadFileSetMetaData(fJSON);
                            loadFileSetRowData(fJSON);

                            props.callbackHandleSetLoadedJSON(fJSON);
                            props.callbackHandleSetStatusInfo("Klassenarbeit " + file.name + " geladen.");
                            console.log("RUNNER IS " + idRunner);

                        }
                    };
                })(file);
                reader.readAsText(file);
            }
            // props.callbackHandleFixStateDataFromGrid(gridRef.current.api);
            e.target.value = "";
        }
        // props.callbackHandleFixStateDataFromGrid(gridRef.current.api); // YYY

    }

    // const getRowId = useMemo(() => {
    //     return (params) => {
    //         return params.data.id;
    //     };
    // }, []);

    const getRowId = (params) => {
        return params.data.id.toString();
    }

    const getNumTasks = () => {
        const currCols = gridRef.current.api.getColumnDefs();
        let numTasks = currCols.length - 4;
        return numTasks;
    }

    const fixNumColsPaste = (exLines) => {
        const numTasks = getNumTasks();
        let numTasksImport = 0;

        for (let i = 0; i < exLines.length; i++) {
            const nTCheck = exLines[i].length - 1;
            numTasksImport = nTCheck > numTasksImport ? nTCheck : numTasksImport;
        }

        let diff = numTasksImport - numTasks;

        if (diff > 0) {
            for (let i = 0; i < diff; i++) {
                changeColumnsAdd(false);
            }
        }
        else if (diff < 0) {
            for (let i = diff; i < 0; i++) {
                changeColumnsRemove();
            }
        }
    };

    const fixNumCols = (exLines) => {
        const numTasks = getNumTasks();
        // const numTasksImport = exLine.trim().split('\t').length - 1;
        // proxy.js:1 Uncaught Error: Attempting to use a disconnected port object
        //at handleMessageFromPage XXX maybe around here!?
        let numTasksImport = 0;
        for (let i = 0; i < exLines.length; i++) {
            console.log(exLines[i]);
            const nTCheck = exLines[i].trim().split('\t').length - 1;
            numTasksImport = nTCheck > numTasksImport ? nTCheck : numTasksImport;
        }

        let diff = numTasksImport - numTasks;

        // console.log("Should fix columns to " + diff);

        if (diff > 0) {
            for (let i = 0; i < diff; i++) {
                changeColumnsAdd(true);
            }
        }
        else if (diff < 0) {
            for (let i = diff; i >= 0; i++) {
                changeColumnsRemove();
            }
        }
    }

    const changeRowsReset = useCallback(e => {
        gridRef.current.api.selectAll();
        const sel = gridRef.current.api.getSelectedRows();
        gridRef.current.api.applyTransaction({ remove: sel });
        gridRef.current.api.setRowData([]);
        gridRef.current.api.setRowData(stdRowData);
        // console.log(stdRowData);
        gridRef.current.api.refreshCells();
        // props.callbackHandleSetStatusInfo("Row Reset?");
    }, []);

    const changeColumnsReset = useCallback(e => {
        gridRef.current.api.setColumnDefs([]);
        gridRef.current.api.setColumnDefs(stdColDefs);
        gridRef.current.api.refreshCells();
        // props.callbackHandleSetStatusInfo("Cols Reset?");
    }, []);

    const pasteFromClipBoard = (row, data) => {
        let sr = gridRef.current.api.getDisplayedRowAtIndex(row);
        let rID = sr.data.id;

        try {
            const newStore = [];

            props.callbackHandleClipboardData(data);
            fixNumColsPaste(data);

            data.map(function (row, rowIndex) {
                row.map(function (cell, cellIndex) {
                    row[cellIndex] = cell.trim();
                });
                const newItem = createNewRowItem(row, rowIndex);
                newStore.push(newItem);
            });
            // setRowData(newStore);
            gridRef.current.api.applyTransaction({ add: newStore });

            props.callbackHandleFixStateDataFromGrid(gridRef.current.api); // YYY
        } catch (error) {
            console.log(error);
        }
        console.log("elvis has left the building");
    }

    const localReadClipboardContents = () => {
        window.focus();
        console.log(navigator.permissions.query({ name: "clipboard-read" }));
        console.log(navigator.permissions);

        let rID = "";
        // let rIdx = -1;
        let sr = gridRef.current.api.getSelectedRows()[0];
        if (sr !== undefined && sr !== null) {
            // rIdx = sr.rowIndex;
            // console.log(sr);
            rID = sr.id;
        }

        // console.log("VVV");
        // console.log(gridRef.current.api.getSelectedRows())
        // console.log(gridRef.current.api.getSelectedRows().length)
        console.log(rID);
        switch (rID) {
            case 'id1':
            case 'id2':
            case 'id3':
                console.log("BIN OBEN!");
                let row = sr;
                console.log(sr);
                console.log("BUN OBEN!");
                navigator.clipboard
                    .readText()
                    .then((clipText) => {
                        console.log(clipText);
                        let tabs = clipText.trim().split('\t');
                        // fixNumCols(clipText); // !!!
                        tabs.map(function (tab, index) {
                            const key = 'a' + (index + 1);
                            row[key] = tab;
                        });
                        console.log(row);
                        gridRef.current.api.refreshCells();
                    });
                break;
            default:
                navigator.clipboard
                    .readText()
                    .then((clipText) => {
                        console.log(clipText);
                        props.callbackHandleClipboardData(clipText);
                        let lines = clipText.split('\n');
                        const newStore = rowData.slice();
                        // console.log(newStore);
                        // console.log(lines);
                        fixNumCols(lines);
                        lines.map(function (item, index) {
                            let tabs = item.trim().split('\t');
                            const newItem = createNewRowItem(tabs, index);
                            newStore.push(newItem);
                        });
                        setRowData(newStore);
                    });
        }

        // let rowCount = gridRef.current.api.getDisplayedRowCount();
        // let newStore = rowData.slice();
        // let newItem = {};
        // for (let i = 0; i < dataBlob.grid.length; i++) {
        //     let pupil = dataBlob.grid[i];
        //     newItem = {
        //         id: rowCount + (i + 1),
        //         // key: "whatsnots", // const key = 'a' + (index - 1);
        //         c0: pupil[0].value,
        //         c1: pupil[1].value,
        //     };
        //     for (let i = 2; i < pupil.length - 2; i++) {
        //         newItem['a' + (i - 1)] = pupil[i].value;
        //     }
        //     newItem['summe'] = pupil[pupil.length - 2].value;
        //     console.log(newItem);
        //     newStore.push(newItem);
        // }
        // setRowData(newStore);
    }

    const genRowData = useCallback(e => {
        console.log("hi from genRowData")
        return rowData;
    })

    // const [columnDefs, setColumnDefs] = useState(stdColDefs);

    // const [columnDefs, setColumnDefs] = useState([
    //     {
    //         field: 'c0',
    //         headerName: "",
    //         suppressMovable: true,
    //         colSpan: p => p.node.rowIndex < 3 ? 2 : 1,
    //         cellStyle: p => p.node.rowIndex < 4 ? { fontWeight: "bold" } : null,
    //         editable: p => p.node.rowIndex < 4 ? false : true
    //     },
    //     {
    //         field: 'c1',
    //         headerName: "",
    //         suppressMovable: true,
    //         cellStyle: p => p.node.rowIndex < 4 ? { fontWeight: "bold" } : null,
    //         editable: params => params.node.rowIndex < 4 ? false : true
    //     },
    //     {
    //         field: 'a1'
    //     },
    //     {
    //         field: 'summe',
    //         headerName: "",
    //         suppressMovable: true,
    //         cellStyle: p => p.node.rowIndex < 4 ? { fontWeight: "bold" } : null,
    //         editable: false,
    //     },
    //     {
    //         field: 'note',
    //         headerName: "Notenschlüssel",
    //         suppressMovable: true,
    //         cellStyle: p => p.node.rowIndex < 4 ? { fontWeight: "bold" } : null,
    //         editable: false,
    //     },

    // ]);

    // const [columnDefs, setColumnDefs] = useState([

    //     {
    //         headerName: 'Benennung der Aufgaben',
    //         colSpan: (params) => {
    //             return 4;
    //         },

    //     },
    //     {
    //         field: 'Anforderungsbereiche',
    //     },
    //     { field: 'name', filter: true },
    //     { field: 'vorname', filter: true, editable: true },
    //     {
    //         headerName: 'Header', colSpan: 2,
    //         children: [
    //             { field: 'some' },
    //             { field: 'thing' },

    //         ]
    //     }
    // ]);

    const timerId = useRef(null);

    const debouncedUpdateFromGrid = useCallback(
        (api) => {
            if (timerId.current !== null) {
                clearTimeout(timerId.current);
            }
            timerId.current = setTimeout(() => {
                props.callbackHandleFixStateDataFromGrid(api);
                timerId.current = null;
            }, 200);
        },
        []
    );

    useEffect(() => () => {
        if (timerId.current !== null) clearTimeout(timerId.current);
    }, []);

    const autoApplyGKRef = useRef(autoApplyGK);
    useEffect(() => {
        autoApplyGKRef.current = autoApplyGK;
    }, [autoApplyGK]);

    const defaultColDef = useMemo(() => ({
        resizable: true,
        editable: true,
        sortable: false,
        width: 5,
        suppressMovable: true,
        suppressMenu: true,
        filter: false,
        flex: 1,
        lockVisible: true,
        onCellValueChanged: (params) => {
            console.log("cellValueChanged");
            const gK = props.callbackHandleGetGK();
            console.log(gK, autoApplyGKRef.current);
            if (gK && autoApplyGKRef.current) handleChangeNotenschluessel(gK);
            debouncedUpdateFromGrid(gridRef.current.api);
        },
        mainMenuItems: () => [{ name: 'In Arbeit...' }],
    }),
        [props, debouncedUpdateFromGrid, autoApplyGK]
    );

    const getNextFreeRowID = () => {
        let usedIDs = [];
        gridRef.current.api.forEachNode((rowNode, index) => {
            if (index > 3) {
                usedIDs.push(rowNode.id);
            }
            // console.log("l " + usedIDs.length);
            // console.log("max " + Math.max(...usedIDs));
        });
        return usedIDs.length > 0 ? Math.max(...usedIDs) + 1 : 1;
    }

    const cellClickedListener = useCallback(event => {
        console.log('cellClicked', event);
        if (event.column.colId === "action" && event.event.target.dataset.action === "delete") {
            console.log("desperately deleting: " + event.node.id);
            console.log(event.node)
            event.api.applyTransaction({
                // remove: [event.node.data],
                // remove: [event.node],
                // remove: [event.api.getRowNode(event.node.id).data],
                // remove: [event.api.getRowNode(event.node.id)],
                // remove: [{ id: event.node.id.toString() }],
                remove: [{ id: event.node.id }],
                // remove: [event.node.id],
            });
            // delete event.node.data;
            // delete event.node;
            props.callbackHandleNumOfPupils(-1);
            // props.callbackHandleFixStateDataFromGrid(gridRef.current.api); // YYY
        }
        if (event.column.colId === "action" && event.event.target.dataset.action === "add") {
            console.log("should add line")

            idRunner++;
            // let rowCount = gridRef.current.api.getDisplayedRowCount();
            let nextID = getNextFreeRowID();
            const item = {
                id: nextID,
                // id: rowCount + 1,
                // id: idRunner,
                c0: "",
                c1: "",
            };
            console.log(item);
            event.api.applyTransaction({
                add: [item],
            });
            props.callbackHandleNumOfPupils(1);
            // props.callbackHandleFixStateDataFromGrid(gridRef.current.api); // YYY
            // console.log(gridRef.current.props.rowData);
        }
    }, []);

    const buttonListener = useCallback(e => {
        // gridRef.current.api.deselectAll();
    }, []);

    const fitMP = (p) => {
        if (p.data.id === "id3") {
            if (p.newValue < 0) {
                return "0";
            }
            else {
                return p.newValue;
            }
        }

        const nV = p.newValue;
        const id = p.column.colId;
        const mV = gridRef.current.api.getRowNode('id3').data[id];
        // const gK = props.callbackHandleGetGK();

        // console.log(p);
        console.log("nV: " + typeof (nV) + " mV: " + typeof (mV) + " id: " + id);
        console.log("nV: " + (nV) + " mV: " + (mV) + " id: " + id);

        // console.log("GK: " + props.callbackHandleGetGK());

        if (parseFloat(nV) > parseFloat(mV)) {
            return mV;
        }
        else {
            return nV >= 0 ? nV : "0";
        }
    }

    const changeColumnsAdd = (freshLoad) => {

        const currCols = gridRef.current.api.getColumnDefs();
        let numTasks = currCols.length - 5;

        // console.log("pushing col!!!");

        const newColDef = {
            field: 'a' + (numTasks + 1),
            lockVisible: true,
            suppressMovable: true,
            width: 5,
            editable: params => (params.node.rowIndex === 3) ? false : true,
            valueSetter: params => {
                let name = 'a' + (numTasks + 1);

                if (params.node.rowIndex < 2) {
                    params.data[name] = params.newValue;
                }
                if (params.node.rowIndex > 3 || params.node.rowIndex === 2) {
                    params.newValue = params.newValue.replace(",", ".");
                    if (isNumeric(params.newValue)) {
                        params.data[name] = fitMP(params);
                        // const gK = props.callbackHandleGetGK();
                        // if (gK !== undefined && gK !== null && gK !== 0) {
                        //     // console.log("GK: " + gK);
                        //     console.log("should hammer update on gk");
                        //     // props.callbackHandleFixStateDataFromGrid(gridRef.current.api); // YYY
                        //     handleChangeNotenschluessel(gK);
                        // }
                    }
                }
                return true;
            },
            headerComponent: C_CustomHeaderRemoveColumn,
        };
        currCols.splice(-3, 0, newColDef);
        gridRef.current.api.updateGridOptions({
            columnDefs: currCols
        });

        gridRef.current.api.getRowNode('id3').data['a' + (numTasks + 1)] = "0";
        gridRef.current.api.getRowNode('id1').data['a' + (numTasks + 1)] = "A" + (numTasks + 1);
        // props.callbackHandleFixStateDataFromGrid(gridRef.current.api);
        if (!freshLoad) {
            props.callbackHandleNumOfTasks(1);
        }
    }


    // const changeColumnsAdd = useCallback(e => {
    //     const currCols = gridRef.current.api.getColumnDefs();
    //     let numTasks = currCols.length - 5; //-5

    //     currCols.splice(-3, 0,
    //         {
    //             field: 'a' + (numTasks + 1),
    //             lockVisible: true,
    //             suppressMovable: true,
    //             width: 5,
    //             editable: params => (params.node.rowIndex === 3) ? false : true,
    //             valueSetter: params => {
    //                 let name = 'a' + (numTasks + 1);

    //                 if (params.node.rowIndex < 2) {
    //                     params.data[name] = params.newValue;
    //                 }
    //                 if (params.node.rowIndex > 3 ||
    //                     params.node.rowIndex === 2) {
    //                     params.newValue = params.newValue.replace(",", ".");

    //                     if (isNumeric(params.newValue)) {
    //                         // params.data[name] = params.newValue;
    //                         params.data[name] = fitMP(params);
    //                     }
    //                     // console.log(params.data[name]);
    //                 }
    //                 return true;
    //             },
    //             headerComponent: C_CustomHeaderRemoveColumn,
    //         }
    //     );
    //     console.log(currCols);
    //     gridRef.current.api.getRowNode('id3').data['a' + (numTasks + 1)] = "0";

    //     gridRef.current.api.setColumnDefs(currCols);
    //     console.log("E IS " + e);
    //     if (e) {
    //         props.callbackHandleNumOfTasks(1);
    //     }

    // }, [stdColDefs]);

    const changeColumnsLoad = useCallback(numTasks => {
        const currCols = stdColDefs;
        // currCols.splice(2, 2);
        console.log(currCols, numTasks);
        for (let i = 1; i <= numTasks; i++) {
            currCols.splice(-3, 0,
                {
                    field: 'a' + i,
                    lockVisible: true,
                    suppressMovable: true,
                    width: 5,
                    editable: params => (params.node.rowIndex === 3) ? false : true,
                    valueSetter: params => {
                        // console.log(params.node);
                        let name = 'a' + i;
                        if (params.node.rowIndex < 2) {
                            // params.data.'a' + i = params.newValue;
                            params.data[name] = params.newValue;
                        }
                        if (params.node.rowIndex > 3 ||
                            params.node.rowIndex === 2) {
                            if (isNumeric(params.newValue)) {
                                params.data[name] = params.newValue;
                            }
                        }
                        return true;
                    },
                    headerComponent: C_CustomHeaderRemoveColumn,
                }
            );
            gridRef.current.api.setColumnDefs(currCols);
        }
    }, [stdColDefs]);

    const changeColumnsRemove = useCallback(e => {
        console.log("should remove column");

        const currCols = gridRef.current.api.getColumnDefs();

        if (currCols.length > 5) {
            // Identify the column to remove
            const rColId = currCols[currCols.length - 4].colId;
            console.log(rColId);

            // Remove the column definition
            currCols.splice(-4, 1);
            console.log(currCols);

            // Update the grid options with the modified column definitions
            gridRef.current.api.updateGridOptions({
                columnDefs: currCols
            });

            // Update the row data to remove the field corresponding to the removed column
            gridRef.current.api.forEachNode((rowNode, index) => {
                if (rowNode.data.hasOwnProperty(rColId)) {
                    switch (index) {
                        case 0:
                        case 1:
                        case 3:
                            rowNode.data[rColId] = "";
                            break;
                        default:
                            rowNode.data[rColId] = "0";
                            break;
                    }
                    delete rowNode.data[rColId];  // Remove the property entirely
                }
            });

            props.callbackHandleNumOfTasks(-1);
        }
        // props.callbackHandleFixStateDataFromGrid(gridRef.current.api); // YYY
    }, [gridRef, stdColDefs, props]);

    // const changeColumnsRemove = useCallback(e => {
    //     console.log("should remove column");
    //     const currCols = gridRef.current.api.getColumnDefs();
    //     if (currCols.length > 5) {
    //         let rColId = currCols[currCols.length - 4].colId;
    //         console.log(rColId);
    //         currCols.splice(-4, 1);
    //         console.log(currCols);
    //         gridRef.current.api.setColumnDefs([]);
    //         gridRef.current.api.setColumnDefs(currCols);

    //         gridRef.current.api.forEachNode((rowNode, index) => {
    //             if (rowNode.data.hasOwnProperty(rColId)) {
    //                 switch (index) {
    //                     case 0:
    //                     case 1:
    //                     case 3:
    //                         rowNode.data[rColId] = "";
    //                         delete rowNode.data[rColId];
    //                         break;
    //                     default:
    //                         rowNode.data[rColId] = "0";
    //                         delete rowNode.data[rColId];
    //                         break;
    //                 }
    //             }
    //         });
    //         props.callbackHandleNumOfTasks(-1);
    //     }

    // }, [stdColDefs]);

    // use call back?
    const onGridReady = (params) => {
        // console.log("i am ready - ongridready called");

        // gridApiRef.current = params.api;
        // columnApiRef.current = params.columnApi;
        // console.log("Grid is ready with API:", gridApiRef.current);

        let fJSON = props.parentState;
        let numTasks = fJSON.taskNames[0].length - 2;

        loadFileFixColumns(numTasks, true); // XXXX
        loadFilePrepareRows();
        loadFileSetMetaData(fJSON);
        loadFileSetRowData(fJSON);

        // props.callbackHandleFixStateDataFromGrid(gridRef.current.api); // YYY
    }

    const handleKeyDown = (event) => {
        // console.log(gridRef.current.api.getSelectedRows());
        // console.log(gridRef.current.api.getSelectedNodes());
        // console.log(event)
        // // event.preventDefault();
        // let charCode = String.fromCharCode(event.which).toLowerCase();
        // if ((event.ctrlKey || event.metaKey) && charCode === 's') {
        //     alert("CTRL+S Pressed");
        // } else if ((event.ctrlKey || event.metaKey) && charCode === 'c') {
        //     alert("CTRL+C Pressed");
        // } else if ((event.ctrlKey || event.metaKey) && charCode === 'v') {
        //     alert("CTRL+V Pressed");
        //     localReadClipboardContents();
        // }
    }

    // const handleParentStateUpdates = (p) => {
    //     console.log("SHould handle parentstate ", p);
    // }

    // console.log("should do business now!");
    // loadFilePrepareColumns(10);

    const forceUpdate = useForceUpdate();



    const getContextMenuItems = (params) => {
        console.log(params);
        if (!params.node) {
            return [
                {
                    name: 'Adjust Columns',
                    action: () => {
                        gridRef.current.api.sizeColumnsToFit();
                    },
                },
            ];
        }

        return [
            'copy',
            // 'paste',
            {
                name: 'Export to CSV',
                action: () => {
                    props.callbackHandleSaveCSV();
                },
                icon: '<i className="bi bi-filetype-csv"></i>'
            }
        ];
    };

    return (
        <>
            {/* <div id="layout"> */}

            {/* <div id="menu">
                    <div className="pure-menu">
                        <div id="pguser">
                            <h4>Unterrichtsentwicklung mit Ergebnissen von Klassenarbeiten</h4>
                        </div>

                        <ul className="pure-menu-list">
                            <li className="pure-menu-item">
                                <a href="/" className="pure-menu-link">
                                    <i className="ico">&#x23CE;</i>
                                    &nbsp;Zur&uuml;ck zur Tool-Auswahl
                                </a>
                            </li>
                            <li className="pure-menu-item">
                                <label className="pointerFinger vanishLabel" htmlFor="inputFileUpload">
                                    <a className="pure-menu-link">
                                        <i className="ico">&#8679;</i>
                                        &nbsp;Klassenarbeit laden</a>
                                    <input id="inputFileUpload" type="file" onClick={props.callbackHandleFileLoadClick}
                                        onChange={e => localHandleFileLoadChange(e, this)} />
                                </label>
                            </li>

                            <li className="pure-menu-item pointerFinger">
                                <a onClick={e => props.callbackHandleSave(gridRef.current.api)} className="pure-menu-link">
                                    <i className="ico">&#8681;</i>
                                    &nbsp;Klassenarbeit speichern</a>
                            </li>
                            <li className="pure-menu-item pointerFinger">

                                <a onClick={e => props.callbackHandleSaveCSV(gridRef.current.api)} className="pure-menu-link">
                                    <i className="ico">&#8681;</i>
                                    &nbsp;Klassenarbeit exportieren</a>
                            </li>
                            <li className="pure-menu-item pointerFinger">
                                <Link to="/erfassung/auswertung" className="pure-menu-link" onClick={(e) => props.callbackHandleFixStateDataFromGrid(gridRef.current.api)}>
                                    <i className="ico">&#9618;</i>
                                    &nbsp;Klassenarbeit auswerten
                                </Link>
                            </li>
                            <li className="pure-menu-item pointerFinger">
                                <a onClick={onBtPrint} className="pure-menu-link">
                                    <i className="ico">&#9113;</i>
                                    &nbsp;Notenliste drucken</a></li>
                            <li className="pure-menu-item pointerFinger">
                                <a onClick={onBtVideoTutorial} className="pure-menu-link">
                                    <i className="ico">&#8505;</i>
                                    &nbsp;Video Tutorial</a>
                            </li>
                            <li className="pure-menu-item pointerFinger">
                                <a onClick={props.callbackHandleReset} className="pure-menu-link">
                                    <i className="ico">&#9673;</i>
                                    &nbsp;Zurücksetzen</a></li>

                        </ul>
                    </div>
                    <div className="statusInfoBlock">
                        {renderStatusBlock()}
                        <span id="clipBoardInfo"></span>
                    </div>
                    <textarea id="txtPasteCB" className="displayNone" />

                </div> */}


            <h5>{strMainHeadline}</h5>
            {/* <div className="statusInfoBox">{props.callbackHandleStatusNotice()}</div> */}

            <Form>
                <Row>
                    {/* Schuljahr Input */}
                    <Col lg={4} md={6} xs={12}>
                        <OverlayTrigger
                            placement="top"
                            delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                            overlay={<Tooltip className="custom-tooltip"
                                id="tooltipSchuljahr">Bitte geben Sie das Schuljahr an (z.B. 2024/2025)</Tooltip>
                            }
                            show={props.parentState.helper.tooltips ? undefined : false}
                        >
                            <FloatingLabel controlId="txtSchuljahr" label="Schuljahr" className="mb-2">
                                <Form.Control
                                    type="text"
                                    defaultValue={props.parentState.schuljahr}
                                    onChange={e => props.callbackHandleChangeSchuljahr(e.target.value)}
                                    placeholder="Bitte geben Sie das Schuljahr an"
                                />
                            </FloatingLabel>
                        </OverlayTrigger>

                    </Col>

                    {/* Fach Input */}
                    <Col lg={4} md={6} xs={12}>
                        <OverlayTrigger
                            delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                            placement="top"
                            overlay={<Tooltip className="custom-tooltip"
                                id="tooltipFachKANummer">Bitte tragen Sie das Fach und ggf. die KA-Nummer ein (z.B. Ethik / KA2)</Tooltip>
                            }
                            show={props.parentState.helper.tooltips ? undefined : false}
                        >
                            <FloatingLabel controlId="txtFach" label="Fach / KA-Nummer" className="mb-2">
                                <Form.Control
                                    type="text"
                                    defaultValue={props.parentState.fach}
                                    onChange={e => props.callbackHandleChangeFach(e.target.value)}
                                    placeholder="Bitte geben Sie das Fach und ggf. die KA-Nummer an"
                                />
                            </FloatingLabel>
                        </OverlayTrigger>
                    </Col>

                    {/* Klasse Input */}
                    <Col lg={4} md={6} xs={12}>
                        <OverlayTrigger
                            delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                            placement="top"
                            overlay={<Tooltip className="custom-tooltip"
                                id="tooltipKlasse">Bitte geben Sie die Klasse an (z.B. E2FSI3)</Tooltip>
                            }
                            show={props.parentState.helper.tooltips ? undefined : false}
                        >
                            <FloatingLabel controlId="txtKlasse" label="Klasse" className="mb-2">
                                <Form.Control
                                    type="text"
                                    defaultValue={props.parentState.klasse}
                                    onChange={e => props.callbackHandleChangeKlasse(e.target.value)}
                                    placeholder="Bitte geben Sie die Klasse an"
                                />
                            </FloatingLabel>
                        </OverlayTrigger>
                    </Col>
                </Row>

                <div className="d-flex justify-content-between align-items-center mb-0 py-0">

                    {/* headline (left) */}
                    <h5 className="mb-0">Notenschlüssel anwenden</h5>

                    {/* switch + label + tooltip (right) */}
                    <OverlayTrigger
                        placement="top"
                        delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                        overlay={
                            <Tooltip id="tooltip-autoapply" className="custom-tooltip">
                                {autoApplyGK ? 'Der von Ihnen ausgewählte Notenschlüssel wird bei jeder Änderung der Daten erneut angewandt.'
                                    : 'Um einen Notenschlüssel auf Ihre Eingaben anzuwenden, muss dieser manuell ausgewählt werden.'}
                            </Tooltip>
                        }
                        show={props.parentState.helper.tooltips ? undefined : false}
                    >
                        <Form.Check
                            type="switch"
                            id="cb_autoapply_gk"
                            name="checkbox_autoapply_gk"
                            checked={autoApplyGK}
                            onChange={e => setAutoApplyGK(e.target.checked)}
                            className="pointerFinger d-flex align-items-center mb-0 mt-0"
                            label={
                                <span
                                    className={`ms-2 pointerHelp ${autoApplyGK ? 'fw-bold text-success' : ''
                                        }`}
                                >
                                    {autoApplyGK ? 'aktiv' : 'inaktiv'}
                                </span>
                            }
                        />
                    </OverlayTrigger>
                </div>

                {/* <h5 className="mb-3">Notenschlüssel anwenden</h5>

                <OverlayTrigger
                    placement="top"
                    delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                    overlay={
                        <Tooltip id="tooltip-autoapply"
                            className="custom-tooltipper"
                        >
                            Schwurbelkoddddfferhausen
                        </Tooltip>
                    }
                >
                    <Form.Check type="switch" className="pointerFinger" id="cb_autoapply_gk">
                        <Form.Check.Input
                            type="checkbox"
                            name="checkbox_autoapply_gk"
                            checked={autoApplyGK}
                            onChange={e => setAutoApplyGK(e.target.checked)}
                        />
                        <Form.Check.Label
                            htmlFor="cb_autoapply_gk"
                            className={`pointerHelp ${autoApplyGK ? 'fw-bold text-success' : ''}`}
                        >
                            KofferhausevvvvSchwurbel
                        </Form.Check.Label>
                    </Form.Check>


                </OverlayTrigger> */}

                <Row>
                    <Col lg={8} md={6} xs={12}>
                        <FloatingLabel controlId="selectGK" label="Notenschlüssel" className="mb-3">
                            <Form.Select
                                className="pointerFinger"
                                aria-label="Notenschlüssel auswählen"
                                onChange={handleGradesKeyChanged}
                            >
                                <option value="0">{placeholderText}</option>
                                <option value="1">Linear</option>
                                {/* <option value="7">Abitur 30 VP (bis 2023)</option>
                                <option value="2">Abitur 60 VP (bis 2023)</option>
                                <option value="3">Abitur 90 VP (bis 2023)</option> */}
                                <option value="12">Abitur 30 BE (ab 2024)</option>
                                <option value="8">Abitur 80 BE (ab 2024)</option>
                                <option value="9">Abitur 90 BE (ab 2024)</option>
                                <option value="10">Abitur 100 BE (ab 2024)</option>
                                <option value="11">Abitur 120 BE (ab 2024)</option>
                                <option value="4">FHSR 60 Punkte</option>
                                <option value="5">FHSR 90 Punkte</option>
                                <option value="6">IHK 100 Punkte</option>
                            </Form.Select>
                        </FloatingLabel>
                    </Col>
                    <Col lg={4} md={6} xs={12}>
                        <OverlayTrigger
                            delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                            placement="top"
                            overlay={<Tooltip className="custom-tooltip"
                                id="tooltipAbiMaxPkt">Wenn Sie einen Abitur-Notenschlüssel anwenden, können Sie hier die Maximalpunkte eingeben, um die Bewertungseinheiten zu skalieren.</Tooltip>
                            }
                            show={props.parentState.helper.tooltips ? undefined : false}
                        >
                            <FloatingLabel controlId="txtMaxPunkte" label="Maximalpunktzahl (Abitur)" className="mb-3">
                                <Form.Control
                                    type="text"
                                    defaultValue={props.parentState.realMaxPoints}
                                    onChange={e => props.callbackHandleChangeRealMaxPoints(e.target)}
                                    placeholder="Bitte geben Sie ggf. die erreichbare Maximalpunktzahl (nur Abi-Schlüssel) an"
                                />
                            </FloatingLabel>
                        </OverlayTrigger>
                    </Col>
                </Row>
                <Row>
                    <Col lg={12} md={12} xs={12}>
                        <h5 className="mb-1">
                            <span
                                onClick={() => setShowPedestalForm(!showPedestalForm)}
                                className={`pointerFinger ${!showPedestalForm ? 'text-muted' : ''}`}
                                style={{ color: !showPedestalForm ? '#b0b0b0' : '', opacity: !showPedestalForm ? 0.6 : 1 }}
                            >
                                Einstellungen linearer Notenschlüssel <i className="bi bi-chevron-expand"></i>
                            </span>
                        </h5>
                    </Col>
                    {/* <Col lg={8} md={6} xs={12}>
                        <h5 className="mb-1 ps-3">
                            <span
                                onClick={() => setShowVisualGK(!showVisualGK)}
                                className={`pointerFinger ${!showVisualGK ? 'text-muted' : ''}`}
                                style={{ color: !showVisualGK ? '#b0b0b0' : '', opacity: !showVisualGK ? 0.6 : 1 }}
                            >
                                Visuelle Darstellung <i className="bi bi-chevron-expand"></i>
                            </span>
                        </h5>

                    </Col> */}
                </Row>
                {/* <h5 className="mb-3">
                    <span
                        onClick={() => setShowPedestalForm(!showPedestalForm)}
                        className={`pointerFinger ${!showPedestalForm ? 'text-muted' : ''}`}
                        style={{ color: !showPedestalForm ? '#b0b0b0' : '', opacity: !showPedestalForm ? 0.6 : 1 }}
                    >
                        Einstellungen linearer Notenschlüssel <i className="bi bi-chevron-expand"></i>
                    </span>
                    <span
                        onClick={() => setShowVisualGK(!showVisualGK)}
                        className={`pointerFinger ${!showVisualGK ? 'text-muted' : ''}`}
                        style={{ color: !showVisualGK ? '#b0b0b0' : '', opacity: !showVisualGK ? 0.6 : 1 }}
                    >
                        Visuelle Darstellung <i className="bi bi-chevron-expand"></i>
                    </span>
                </h5> */}
                <CSSTransition
                    in={showPedestalForm}
                    timeout={300}
                    classNames="fade"
                    unmountOnExit
                >
                    <>
                        <Row className="my-0">
                            <Col lg={4} md={6} xs={12}>
                                <OverlayTrigger
                                    delay={{ show: props.default_tooltip_show, hide: props.default_tooltip_hide }}
                                    placement="top"
                                    overlay={
                                        <Tooltip className="custom-tooltip" id="tooltipSockelUnten">
                                            Bitte geben Sie an, bis zu wie vielen Punkten (und darunter) die schlechteste Note vergeben wird (sog. Sockel unten).
                                        </Tooltip>
                                    }
                                >
                                    <div className="mb-3">
                                        <label htmlFor="rangeSliderSockelUnten" className="form-label">
                                            Schlechteste Note vergeben bis ...
                                        </label>

                                        <Row className="align-items-center">
                                            <Col xs={9}>
                                                <Form.Range
                                                    id="rangeSliderSockelUnten"
                                                    min={0}
                                                    max={props.callbackGetMaxPointsSum()}
                                                    // defaultValue={0}
                                                    // value={props.parentState.sockelUnten ?? 0}
                                                    value={Number.isNaN(props.parentState.sockelUnten) ? 0 : props.parentState.sockelUnten}
                                                    onChange={(e) => props.callbackHandleChangeSockelUnten(e.target)}
                                                />
                                            </Col>
                                            <Col xs={3}>
                                                <div className="slider-value">
                                                    {/* {props.parentState.sockelUnten ?? 0} */}
                                                    {Number.isNaN(props.parentState.sockelUnten) ? "0" : props.parentState.sockelUnten}
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </OverlayTrigger>
                            </Col>
                            <Col lg={4} md={6} xs={12}>
                                <OverlayTrigger
                                    delay={{ show: props.default_tooltip_show, hide: props.default_tooltip_hide }}
                                    placement="top"
                                    overlay={
                                        <Tooltip className="custom-tooltip" id="tooltipSockelUnten">
                                            Legen Sie fest, mit wie vielen Punkten die Note 4,4 (ausreichend) erreicht wird (sog. Knick).
                                        </Tooltip>
                                    }
                                >
                                    <div className="mb-3">
                                        <label htmlFor="rangeSliderSockelKnick" className="form-label">
                                            Punkte für 'ausreichend' ...
                                        </label>

                                        <Row className="align-items-center">
                                            <Col xs={9}>
                                                <Form.Range
                                                    id="rangeSliderKnick"
                                                    min={0}
                                                    max={props.callbackGetMaxPointsSum()}
                                                    // defaultValue={0}
                                                    value={props.parentState.knick ?? 0}
                                                    onChange={(e) => props.callbackHandleChangeKnick(e.target)}
                                                />
                                            </Col>
                                            <Col xs={3}>
                                                <div className="slider-value">
                                                    {props.parentState.knick ?? 0}
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </OverlayTrigger>
                            </Col>

                            <Col lg={4} md={6} xs={12}>
                                <OverlayTrigger
                                    delay={{ show: props.default_tooltip_show, hide: props.default_tooltip_hide }}
                                    placement="top"
                                    overlay={
                                        <Tooltip
                                            className="custom-tooltip"
                                            id="tooltipSockelOben">
                                            Geben Sie bitte an, ab wie vielen Punkten (und darüber) die beste Note vergeben wird (sog. Sockel oben).
                                        </Tooltip>
                                    }
                                >
                                    <div className="mb-3">
                                        <label
                                            htmlFor="rangeSliderSockelOben"
                                            className="form-label"
                                        >
                                            Beste Note vergeben ab ...
                                        </label>
                                        <Row className="align-items-center">
                                            <Col xs={9}>
                                                <Form.Range
                                                    id="rangeSliderSockelOben"
                                                    min={0}
                                                    max={props.callbackGetMaxPointsSum()}
                                                    // defaultValue={props.callbackGetMaxPointsSum()}
                                                    value={Number.isNaN(props.parentState.sockelOben) ?
                                                        props.callbackGetMaxPointsSum() : props.parentState.sockelOben}
                                                    // value={props.parentState.sockelOben ?? props.callbackGetMaxPointsSum()}
                                                    onChange={(e) => props.callbackHandleChangeSockelOben(e.target)}
                                                // disabled={props.parentState.knick > 0} // Disable the slider
                                                />
                                            </Col>
                                            <Col xs={3}>
                                                <div className="slider-value">
                                                    {/* {props.parentState.sockelOben ?? props.callbackGetMaxPointsSum()} */}
                                                    {Number.isNaN(props.parentState.sockelOben) ? props.callbackGetMaxPointsSum() : props.parentState.sockelOben}
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </OverlayTrigger>
                            </Col>

                        </Row>
                        {/* <Row className="my-0">


                        <Col lg={4} md={6} xs={12}>
                            <OverlayTrigger
                                delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                placement="top"
                                overlay={<Tooltip className="custom-tooltip" id="tooltipSockelOben">
                                    Geben Sie bitte an, ab wie vielen Punkten (und darüber) die beste Note vergeben wird.
                                </Tooltip>}
                            >
                                <FloatingLabel controlId="txtSockelOben" label="Beste Note vergeben ab ..." className="mb-3">
                                    <Form.Control
                                        type="text"
                                        value={props.parentState.sockelOben}
                                        onChange={e => props.callbackHandleChangeSockelOben(e.target)}
                                        placeholder="Bitte geben Sie den oberen Sockelpunkt an"
                                    />
                                </FloatingLabel>
                            </OverlayTrigger>
                        </Col>
                        <Col lg={4} md={6} xs={12}>
                            <OverlayTrigger
                                delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                placement="top"
                                overlay={<Tooltip className="custom-tooltip" id="tooltipSockelUnten">
                                    Bitte geben Sie an, bis zu wie vielen Punkten (und darunter) die schlechteste Note vergeben wird.
                                </Tooltip>}
                            >
                                <FloatingLabel controlId="txtSockelUnten" label="Schlechteste Note vergeben bis ..." className="mb-3">
                                    <Form.Control
                                        type="text"
                                        defaultValue={props.parentState.sockelUnten}
                                        onChange={e => props.callbackHandleChangeSockelUnten(e.target)}
                                        placeholder="Bitte geben Sie den unteren Sockelpunkt an"
                                    />
                                </FloatingLabel>
                            </OverlayTrigger>
                        </Col>
                        <Col lg={4} md={6} xs={12}>
                            <OverlayTrigger
                                delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                placement="top"
                                overlay={<Tooltip className="custom-tooltip" id="tooltipKnick">
                                    Sie können hier festlegen, mit wie vielen Punkten die Note 4,4 (ausreichend) erreicht wird (sog. Knick).
                                </Tooltip>}
                            >
                                <FloatingLabel controlId="txtKnick" label="Punkte für 'ausreichend' festlegen" className="mb-3">
                                    <Form.Control
                                        type="text"
                                        defaultValue={props.parentState.knick}

                                        onChange={e => props.callbackHandleChangeKnick(e.target)}
                                        placeholder="Bitte geben Sie den Knickpunkt an"
                                    />
                                </FloatingLabel>
                            </OverlayTrigger>
                        </Col>
                    </Row> */}


                        {
                            showVisualGK && (
                                <Row>
                                    <Col>
                                        <GradeChart data={data} parentState={props.parentState} />

                                    </Col>
                                </Row>
                            )

                        }
                    </>
                </CSSTransition>


            </Form>

            {/* <button onClick={openFullscreen}>Open Fullscreen Chart</button>
            {isFullscreen && (
                <div className="fullscreen-overlay" onClick={closeFullscreen}>
                    <div>
                        <button onClick={closeFullscreen}>Close</button>
                        <GradeChart data={data} />
                    </div>
                </div>
            )} */}


            {/* <form> */}


            {/* <div className="form-floating mb-3">
                    <input type="text" id="txtSchuljahr" defaultValue={props.parentState.schuljahr}
                        onChange={e => props.callbackHandleChangeSchuljahr(e.target.value)}
                        placeholder='Bitte geben Sie das Schulahr an'
                        className="form-control" />
                    <label htmlFor="txtSchuljahr">Bitte geben Sie das Schuljahr an</label>
                </div>

                <div className="form-floating mb-3">
                    <input type="text" id="txtFach"
                        defaultValue={props.parentState.fach}
                        onChange={e => props.callbackHandleChangeFach(e.target.value)}
                        placeholder='Bitte geben Sie das Fach und ggf. die KA-Nummer an'
                        className="form-control" />
                    <label htmlFor="txtFach">Bitte geben Sie das Fach und ggf. die KA-Nummer an</label>
                </div>

                <div className="form-floating mb-3">
                    <input type="text" id="txtKlasse"
                        defaultValue={props.parentState.klasse}
                        onChange={e => props.callbackHandleChangeKlasse(e.target.value)}
                        placeholder='Bitte geben Sie die Klasse an'
                        className="form-control" />
                    <label htmlFor="txtKlasse">Bitte geben Sie die Klasse an</label>
                </div> */}






            {/* 

                <div className="form-floating mb-3">

                    <input type="text" id="txtMaxPunkte" className="form-control"
                        defaultValue={props.parentState.realMaxPoints}
                        onChange={e => props.callbackHandleChangeRealMaxPoints(e.target)}
                        placeholder='Bitte geben Sie ggf. die erreichbare Maximalpunktzahl (nur Abi-Schlüssel) an'
                    />
                    <label htmlFor="txtMaxPunkte">Bitte geben Sie ggf. die erreichbare Maximalpunktzahl (nur Abi-Schlüssel) an</label>
                </div>

                <div className="form-floating">
                    <select className="pointerFinger form-select" id="selectGK" aria-label="Noteschlüssel auswählen"
                        onChange={handleGradesKeyChanged}>
                        <option value="0">Notenschlüssel...</option>
                        <option value="1">Linear</option>
                        <option value="7">Abitur 30 VP (bis 2023)</option>
                        <option value="2">Abitur 60 VP (bis 2023)</option>
                        <option value="3">Abitur 90 VP (bis 2023)</option>
                        <option value="12">Abitur 30 BE (ab 2024)</option>
                        <option value="8">Abitur 80 BE (ab 2024)</option>
                        <option value="9">Abitur 90 BE (ab 2024)</option>
                        <option value="10">Abitur 100 BE (ab 2024)</option>
                        <option value="11">Abitur 120 BE (ab 2024)</option>
                        <option value="4">FHSR 60 Punkte</option>
                        <option value="5">FHSR 90 Punkte</option>
                        <option value="6">IHK 100 Punkte</option>
                    </select>
                    <label for="selectGK">Wählen Sie einen Notenschlüssel aus, den Sie anwenden wollen</label>
                </div>


            </form> */}




            {/* <div style={{ height: '100%', width: '100%' }}>
                <div id="myGrid" className="ag-theme-alpine"
                    style={{
                        height: "600px",
                        width: "100%",
                        clear: "both"
                    }}
                    // onKeyDown={handleKeyDown}
                > */}

            <div style={{ height: '60vh', width: '100%' }}> {/* Set to fill entire viewport height */}
                <div id="myGrid" className="ag-theme-alpine" style={{ height: '100%', width: '100%' }}>

                    <AgGridReact
                        ref={gridRef}
                        getRowId={getRowId}
                        rowData={rowData}
                        columnDefs={columnDefs}
                        // columnDefs={stdColDefs}
                        defaultColDef={defaultColDef}
                        animateRows={true}
                        rowSelection={'multiple'}
                        suppressCellSelection={false}
                        enableRangeSelection={true}
                        onCellClicked={cellClickedListener}
                        onGridReady={onGridReady}
                        rowDragManaged={true}
                        getContextMenuItems={getContextMenuItems}
                        enableclipboard={true}
                        suppressHeaderContextMenu={true}
                        // domLayout="autoHeight"
                        style={{ width: '100%', height: '100%' }}
                        processDataFromClipboard={processDataFromClipboard}
                    // enableCellChangeFlash={true}
                    // enableRangeSelection={true}
                    >
                    </AgGridReact>
                </div>
            </div>

            {/* </div> */}
            {/* <iframe title="ifprint" id="ifprint"></iframe> */}
        </>
    );
});

export default MainGrid;
